require.register("app/restaurant/analyse/product/TempForm", function(exports, require, module){
  $0
  
});

